import React from "react";
import { useGridRowCount } from "src/hooks/useGridRowCount";

interface GridRowCountProps {
  gridId: string;
  children?: (count: number) => React.ReactNode;
}

const GridRowCount = ({ gridId, children }: GridRowCountProps) => {
  const count = useGridRowCount(gridId);

  if (children) {
    return <>{children(count)}</>;
  }

  return <>{count}</>;
};

export default GridRowCount;
